export default {
  olsHost: 'https://{websiteId}.onlinestore.test-godaddy.com',
  olsPublishedSiteHost: 'https://{websiteId}.mysimplestore.test-godaddy.com',
  formSubmitHost: 'https://gem.apps.test-godaddy.com'
};
